<script lang="ts" setup>
defineOptions({
  name: 'CarouselItemGroup',
});
</script>

<template>
  <div
    class="embla__container embla__item-group"
    data-scope="carousel"
    data-part="item-group"
    aria-live="polite"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.embla__container {
  display: flex;
  margin-left: calc(var(--slide-spacing) * -1);
}
</style>
